import React from 'react';
import './Footer.css';
import real_logo from "../real_logo.png";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-grid">
          {/* Company Info Column */}
          <div className="footer-column company-info">
            <div className="footer-logo">
              <img src={real_logo} alt="Company Logo" className="logo-img" />
            </div>
            <div className="company-description">
              <h3>REAL SEATING SYSTEMS</h3>
              <p>Experts in processing cold cured flexible and rigid polyurethane foams. Delivering excellence in manufacturing since 1985.</p>
            </div>
            <div className="contact-info">
              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <span>25 Worcester Rd, Etobicoke, ON M9W 1K9</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📞</span>
                <span>+1(416)367-3626</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">✉️</span>
                <span>info@realformtech.com</span>
              </div>
            </div>
          </div>

          {/* Shortcuts Column */}
          <div className="footer-column">
            <h3 className="column-title">Quick Links</h3>
            <ul className="footer-links">
              <li><a href='/NewDashboard' className="footer-link">Dashboard</a></li>
              <li><a href='/openorder' className="footer-link">PO Open Orders</a></li>
              <li><a href='/pivot' className="footer-link">Pivot Reports</a></li>
              <li><a href='/Supply_Pivot' className="footer-link">Supply Chain</a></li>
              <li><a href='/Production' className="footer-link">Production</a></li>
            </ul>
          </div>

          {/* Daily Links Column */}
          <div className="footer-column">
            <h3 className="column-title">Daily Operations</h3>
            <ul className="footer-links">
              <li><a href='/attendance' className="footer-link">Attendance</a></li>
              <li><a href='/attendance' className="footer-link">Vacation Requests</a></li>
              <li><a href='/attendanceDetails' className="footer-link">Attendance Details</a></li>
              <li><a href='/Scheduling' className="footer-link">Scheduling</a></li>
              <li><a href='/Maintenance' className="footer-link">Maintenance</a></li>
            </ul>
          </div>

          {/* Other Links Column */}
          <div className="footer-column">
            <h3 className="column-title">Management Tools</h3>
            <ul className="footer-links">
              <li><a href='/BOM' className="footer-link">BOM Management</a></li>
              <li><a href='/BOMPivot' className="footer-link">BOM Pivot</a></li>
              <li><a href='/Supply_Pivot' className="footer-link">Supply Pivot</a></li>
              <li><a href='/PurchaseRequest' className="footer-link">Purchase Requests</a></li>
              <li><a href='/reaminedparts' className="footer-link">Remaining Parts</a></li>
            </ul>
          </div>

          {/* Social/Newsletter Column (Optional) */}

        </div>

        {/* Divider */}
        <div className="footer-divider"></div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="copyright">
            <p>© 2023 Real Form Systems. All rights reserved.</p>
          </div>
          <div className="footer-legal">
            <a href="/privacy" className="legal-link">Privacy Policy</a>
            <a href="/terms" className="legal-link">Terms of Service</a>
            <a href="/sitemap" className="legal-link">Sitemap</a>
            <a href="/contact" className="legal-link">Contact</a>
          </div>

        </div>
      </div>
    </footer>
  );
}